<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .container {
    display: flex;
    height: 100vh;
    width: 100%;
    justify-content: center;
    padding: utils.in_rem(24px);
    align-items: center;
    gap: utils.in_rem(24px);
    background-color: colors.get("interfaceWhite");
  }
</style>

<script>
  import { SvelteURLSearchParams } from "svelte/reactivity";
  import Form from "./Form.svelte";
  import Interest from "./Interest.svelte";
  import Testimonials from "./Testimonials.svelte";

  let params = new SvelteURLSearchParams(window.location.search);
  let paramStatus = $derived(params.get("status"));

  let innerWidth = $state(window.innerWidth);
</script>

<svelte:window bind:innerWidth />

<div class="container">
  {#if paramStatus === "pending"}
    <Interest />
  {:else}
    <Form />
  {/if}
  {#if innerWidth > 768}
    <Testimonials />
  {/if}
</div>
